import * as d3 from "d3";
import IRiskMapData from "../types/IRiskMapData";

const showNumber = (event: any) => {
  const textElement = d3.select(event.currentTarget.nextSibling);
  textElement.attr("opacity", 1);
};
const hideNumber = (event: any) => {
  const textElement = d3.select(event.currentTarget.nextSibling);
  textElement.attr("opacity", 0);
};

export const renderRiskMap = (
  //svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  svg: d3.Selection<SVGGElement, any, null, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  data: IRiskMapData[],
  pitchWidth: number,
  pitchHeight: number
) => {
  const boxWidth = pitchWidth / 20;
  const boxHeight = pitchHeight / 20;
  const blockCounts: { [key: string]: any } = {};
  data.forEach((position: any) => {
    const startX = Math.floor(xScale(position.locationX));
    const startY = Math.floor(yScale(position.locationY));
    const blockX = Math.floor(startX / boxWidth);
    const blockY = Math.floor(startY / boxHeight);
    const key = `${blockX},${blockY}`;
    if (!blockCounts[key]) {
      blockCounts[key] = 0;
    }
    blockCounts[key]++;
  });
  const maxCount: any = Math.max(...Object.values(blockCounts));
  const normalizedBlockCounts: any = {};
  Object.entries(blockCounts).forEach(([key, count]) => {
    normalizedBlockCounts[key] = count / maxCount;
  });
  
  const colorScale = d3
    .scaleSequential()
    .domain([0, 1])
    .interpolator(d3.interpolateOrRd);
  d3.range(pitchWidth / boxWidth).forEach((columnIndex) => {
    d3.range(pitchHeight / boxHeight).forEach((rowIndex) => {
      const x = columnIndex * boxWidth;
      const y = rowIndex * boxHeight;
      const key = `${columnIndex},${rowIndex}`;
      const numberOfEvents: number = blockCounts[key];
      const fillColor = normalizedBlockCounts[key]
        ? colorScale(normalizedBlockCounts[key])
        : "rgba(255, 255, 255, 0)";
      svg
        .append("rect")
        .attr("x", x)
        .attr("y", y)
        .attr("width", boxWidth)
        .attr("height", boxHeight)
        .attr("fill", fillColor)
        .attr("fill-opacity", 1)
        .on("mouseover", function (event) {
          //showNumber(event, numberOfEvents);
          showNumber(event);
        })
        .on("mouseout", hideNumber);
      svg
        .append("text")
        .attr("x", x + boxWidth / 2)
        .attr("y", y + boxHeight / 2)
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "middle")
        .attr("font-size", "25px")
        .attr("font-weight", "bolder")
        .attr("fill", "white")
        .attr("opacity", 0)
        .text(numberOfEvents);
    });
  });
};
